// extracted by mini-css-extract-plugin
module.exports = {"section":"TradeInfoBox_section__elxpa","infoList":"TradeInfoBox_infoList__g0o2P","infoItem":"TradeInfoBox_infoItem__PVuRv"};